<template>
  <div class="manage-members">
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Manage members: {{ project.name }}</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>
          <template v-if="loading">
            <loading />
          </template>
          <div v-for="user in users" :key="user.email" class="member">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 0"
                class="pa-1 d-flex flex-wrap justify-space-between cursor-pointer"
              >
                <div class="mb-1 mb-sm-0 d-flex">
                  <v-avatar color="grey">
                    <v-icon dark>
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                  <div class="ml-1">
                    <h6 class="primary--text pb-0 mb-0">
                      <strong>{{ user.name }}({{ user.role }})</strong>
                    </h6>
                    <div class="grey--text">
                      {{ user.company_name || "N/A" }}
                    </div>
                    <div class="grey--text">{{ user.email }}</div>
                  </div>
                </div>
                <div>
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                      <transition name="slide-fade" mode="out-in">
                        <v-btn icon v-on="on">
                          <v-icon size="32" color="grey">
                            mdi-dots-horizontal
                          </v-icon>
                        </v-btn>
                      </transition>
                    </template>
                    <v-list dense>
                      <v-list-item @click="deactivateModal = true">
                        <v-icon size="18" class="mr-1">mdi-account</v-icon>
                        <v-list-item-title>Deactivate</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteModal = true">
                        <v-icon size="18" class="mr-1">mdi-delete</v-icon>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <div>
                    <span class="success--text">Active</span>
                  </div>
                </div>
              </v-card>
            </v-hover>
            <v-divider class="ma-1"></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DeactivateMember
      v-if="deactivateModal"
      :dialog="deactivateModal"
      @close="deactivateModal = false"
    />

    <DeleteMember
      v-if="deleteModal"
      :dialog="deleteModal"
      @close="deleteModal = false"
    />
  </div>
</template>

<script>
import DeactivateMember from "@/components/project/DeactivateMember";
import DeleteMember from "@/components/project/DeleteMember";
export default {
  components: {
    DeactivateMember,
    DeleteMember
  },

  data() {
    return {
      deactivateModal: false,
      deleteModal: false,
      loading: false,
      users: []
    };
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      default: null,
      required: true
    }
  },

  created() {
    this.getProjectUsers();
  },

  methods: {
    getProjectUsers() {
      this.loading = true;
      this.$store
        .dispatch("project/getProjectUsers", { name: this.project.name })
        .then(resp => {
          this.users = JSON.parse(JSON.stringify(resp.accessList));
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
